import {
  BuffetEpgItem,
  Movie,
  MyChannel,
  TvShow
} from "@/services/apiService/api.types";

export const enum HomePageAction {}

export const enum HomePageMutation {
  setPlayedChannelIndex = "setPlayedChannelIndex",
  setWidgetKeyControl = "setWidgetKeyControl",
  setActiveSlideIndexMap = "setActiveSlideIndexMap",
  resetActiveSlideIndexMap = "resetActiveSlideIndexMap",
  setPlayedWidgetIndex = "setPlayedWidgetIndex",
  setPromotionKeyControl = "setPromotionKeyControl"
}

export const enum HomePageGetter {
  GetPlayedChannelIndex = "GetPlayedChannelIndex",
  GetWidgetKeyControl = "GetWidgetKeyControl",
  GetActiveSlideIndexMap = "GetActiveSlideIndexMap",
  GetPlayedWidgetIndex = "GetPlayedWidgetIndex",
  GetPromotionKeyControl = "GetPromotionKeyControl"
}
export interface HomePageState {
  playedChannelIndex?: number;
  widgetKeyControl: boolean;
  activeSlideIndexMap: Array<number>;
  playedWidgetIndex?: IndexData;
  promotionKeyControl: boolean;
}

export type HomePageWidgetType =
  | BuffetEpgItem[]
  | MyChannel[]
  | TvShow[]
  | Movie[];

export interface IndexData {
  valueIndex: number;
  value: number;
}

export interface SlideIndexMapParams {
  addItem?: boolean;
  slideIndex?: IndexData;
}
